import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './AvatarChoiceSelector.css'; // Asegúrate de crear este archivo de estilos
import Avatar from '../Imagenes/avatar.png';
import Creativo from '../Imagenes/creativo.png';
import { Helmet } from 'react-helmet';
import Modal from './Modal'; // Asegúrate de importar el modal

const AvatarChoiceSelector: React.FC = () => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSingleImageClick = () => {
    history.push('/Social-Networking-Avatar');
  };

  const handleCarouselClick = () => {
    setIsModalOpen(true);  // Abre el modal
  };

  const closeModal = () => {
    setIsModalOpen(false); // Cierra el modal
  };
  return (
    <div className="choice-container">
      <Helmet>
        <title>Avatar - Taapt</title>
      </Helmet>
      <h2>¿Qué deseas <span>crear</span>?</h2>
      <div className="choice-cards">
        <div>
          <div className="choice-card" >
            <div className="icon"><img src={Avatar} alt="" /></div>
            <h3>AVATAR</h3>
            <p>Crea un video explicativo con un avatar.</p>
          </div>
          <button className='Choice-button' onClick={handleSingleImageClick}>✔ Seleccionar</button>
        </div>
        <div>
          <div className="choice-card" >
            <div className="icon"><img src={Creativo} alt="" /></div>
            <h3>CREATIVO</h3>
            <p>Crea un video creativo a partir de un texto. <br/>
            </p>
          </div>
          <button className='Choice-button' onClick={handleCarouselClick}>✔ Seleccionar</button>
        </div>
        {isModalOpen && <Modal message="En desarrollo, próximamente disponible" onClose={closeModal} />}

      </div>
    </div>
  );
};

export default AvatarChoiceSelector;
